module.exports = __webpack_public_path__ + "img/partners_cards.d66a1e09.png";